import { useState, useEffect, useCallback } from 'react';
import { getPrices } from '../services/api';
import './Watchlist.css';

export default function Watchlist({ items, onSelect, onRemove }) {
  const [priceData, setPriceData] = useState({});

  const fetchPrices = useCallback(async () => {
    if (items.length === 0) return;
    try {
      const tickers = items.map((i) => i.ticker);
      const data = await getPrices(tickers);
      const map = {};
      (data.tickers || []).forEach((t) => {
        map[t.ticker] = t;
      });
      setPriceData(map);
    } catch {
      // silently fail
    }
  }, [items]);

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 60000);
    return () => clearInterval(interval);
  }, [fetchPrices]);

  if (items.length === 0) {
    return <div className="watchlist-empty">Your watchlist is empty. Search and add stocks above.</div>;
  }

  return (
    <div className="watchlist">
      {items.map((item) => {
        const info = priceData[item.ticker];
        const price = info?.price || 0;
        const change = info?.change || 0;
        const changePct = info?.changePct || 0;
        const isPositive = change >= 0;

        return (
          <div
            key={item.ticker}
            className="watchlist-item"
            onClick={() => onSelect({ ticker: item.ticker, name: item.name })}
          >
            <div className="watchlist-info">
              <span className="watchlist-ticker">{item.ticker}</span>
              <span className="watchlist-name">{item.name}</span>
            </div>
            <div className="watchlist-price">
              <span className="price-value">{price ? `$${price.toFixed(2)}` : '...'}</span>
              <span className={`price-change ${isPositive ? 'positive' : 'negative'}`}>
                {isPositive ? '+' : ''}{change.toFixed(2)} ({changePct.toFixed(2)}%)
              </span>
            </div>
            <button
              className="btn-remove"
              onClick={(e) => { e.stopPropagation(); onRemove(item.ticker); }}
              title="Remove from watchlist"
            >
              x
            </button>
          </div>
        );
      })}
    </div>
  );
}
